<app-header></app-header>
<section style="margin-top:100px;">
<div class="container">
    <h1>{{ blogData.mainTitle }}</h1>
    <p class="post-excerpt">{{ blogData.mainParagraph }}</p>
    <div class="post-info">{{ blogData.createdAt | date: 'mediumDate'  }}</div>
    <div class="hero-image">
   <img src="{{ BaseUrl }}/{{ blogData.image }}" alt="Pi Network Thumbnail">
    </div>
 <div class="doge-summary">
  <div [innerHTML]="taxInfo"></div>
  </div>
<section style="margin-top:320px;">
    <app-footer></app-footer>
</section>

